import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HeaderSubtitleState {
    headerSubtitle: string;
}

const initialState: HeaderSubtitleState = {
    headerSubtitle: "",
};

const pageHeaderSubtitleSlice = createSlice({
    name: 'pageHeaderSubtitle',
    initialState,
    reducers: {
        setPageHeaderSubtitle(state, action: PayloadAction<{headerSubtitle: string}>) {
            state.headerSubtitle = action.payload.headerSubtitle;
        }
    },
});

export const { setPageHeaderSubtitle } = pageHeaderSubtitleSlice.actions;
export default pageHeaderSubtitleSlice.reducer;
